import { createContext, useContext, type Context } from 'react';

import {
  ConvertibleUnit,
  FormatOptions,
  Unit,
  format,
} from '@dynatrace-sdk/units';

import {
  isFormatterOptions,
  Formatter,
} from '../../../core/types/formatter.js';

export type FormatterContextProps = {
  /**
   * Custom or default formatter for the chart
   * @defaultValue the default formatter
   */
  formatter: Formatter | FormatOptions<Unit, ConvertibleUnit>;
};

export const FormatterContext: Context<FormatterContextProps> =
  createContext<FormatterContextProps>({} as FormatterContextProps);

interface UseFormatterProps {
  formatter: Formatter;
}

export const useFormatter = (): UseFormatterProps => {
  const context = useContext(FormatterContext);

  if (context === undefined) {
    throw new Error('useFormatter must be within FormatterContext');
  }

  const { formatter } = context;

  if (isFormatterOptions(formatter)) {
    return { formatter: (value: number) => format(value, formatter) };
  }

  return { formatter };
};
